import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import './fp3-sign-ins';
import './fp3-users';

type AdminTab = 'people' | 'logs';

@customElement('fp3-admin')
export class Fp3Admin extends LitElement {
  @state() private tab: AdminTab = 'people';

  static styles = css`
    :host { display: block; }
    .tabs {
      display: flex;
      gap: 0.35rem;
      width: fit-content;
      max-width: 100%;
      margin-bottom: 1.1rem;
      padding: 0.3rem;
      border: 1px solid var(--dash-border, #314255);
      border-radius: 12px;
      background: var(--dash-surface, #121a22);
    }
    button {
      font: inherit;
      color: var(--dash-muted, #8fa3b8);
      background: transparent;
      border: 1px solid transparent;
      border-radius: 8px;
      padding: 0.45rem 0.85rem;
      cursor: pointer;
    }
    button:hover { color: var(--dash-text, #e8edf2); background: var(--dash-elevated, #182430); }
    button[aria-pressed='true'] {
      background: var(--dash-accent, #5b9fd4);
      color: #0f1419;
      border-color: var(--dash-accent, #5b9fd4);
      font-weight: 600;
    }
  `;

  render() {
    return html`
      <div class="tabs" role="tablist" aria-label="Admin">
        <button type="button" role="tab" aria-pressed=${this.tab === 'people'} @click=${() => { this.tab = 'people'; }}>
          People
        </button>
        <button type="button" role="tab" aria-pressed=${this.tab === 'logs'} @click=${() => { this.tab = 'logs'; }}>
          Sign in logs
        </button>
      </div>
      ${this.tab === 'logs' ? html`<fp3-sign-ins></fp3-sign-ins>` : html`<fp3-users></fp3-users>`}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fp3-admin': Fp3Admin;
  }
}
